import { Box, Grid, Paper, Snackbar, Table, TableBody, TableContainer, TableHead, TablePagination, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from '../../../styles.module.css';
import { useDispatch, useSelector } from "react-redux";
// import { editDeleteCharges, getChargesList } from "../../../../../actions/actions";
import { ActionMsg, AddButton, Breadcrumb, CustomePopover, DateConversionOnEntryPage, DeleteDialog, ExcelDownload, HandleCloseSnackbar, HandleSort, SearchInput, StyledTableCell, StyledTableRow, useMessageHandler } from "../../reusableComponent/Reusables";
import { rows } from '../MastersFakeDb';
import { editDeleteDepot, getDepotList } from "../../../actions/actions";
import HeaderSection from "../../reusableComponent/HeaderSection";
import depotMasterService from "../../../services/masters/depotMaster.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import CustomPagination from "../../reusableComponent/CustomPagination";

const DepotList = () => {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;

    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState();
    const [sortBy, setSortBy] = useState(null);
    // Move totalCount and other state selectors before useEffect
    const totalCount = useSelector(state => state.depot.total_count || 0);
    const defaultRowsPerPage = useSelector(state => state.depot.rows_per_page || 15);
    // const rows = useSelector(state => state.depot.depot)
    const [rows, setRows] = useState([]);
    const [searchKey, setSearchKey] = useState('');

    const fields = ['depot_name', "depot_address", "contact_person","contact_no"];
    const labels = ['Depot Name ', "Depot Address", "Contact Person","Contact No "];

    //const [successMessage, setSuccessMessage] = useState(null);
    //const respMsgState = 'test'
    // const respMsgState = useSelector((state) => state.unit.message);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: defaultRowsPerPage
    });
    useEffect(() => {
        setController(prev => ({
            ...prev,
            rowsPerPage: defaultRowsPerPage,
            page: 0,
        }));
    }, [defaultRowsPerPage]);


    const handleChangePage = (event, newPage) => {
        setController({
            ...controller,
            page: newPage
        });
    };

    const handleChangeRowsPerPage = (event) => {
        setController({
            ...controller,
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };

 
    const fetchData = async () => {
        try {
            const params = {
                page: controller.page,
                size: controller.rowsPerPage,
                searchKey: searchKey,
            };
            const response = await depotMasterService.getDepotList(params);
            setRows(response);
        } catch (error) {
            setSuccessMessage("Error fetching data");
        }
    };

  
    const handleSearch = async (e) => {
        const searchValue = e.target.value;
        setSearchKey(searchValue);  // Set the search key

        // Prepare the params based on the search value
        const params = {
            page: controller.page,
            size: searchValue === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
            searchKey: searchValue,
        };

        try {
            // Fetch data using the fetchData function (assuming fetchData is already declared)
            await fetchData(params);
        } catch (error) {
            console.error("Error in handleSearch:", error);
        }
    };

    useEffect(() => {
        fetchData()
    }, [controller]);


    
    const deleteRecord = async (id) => {
        try {
            await depotMasterService.editDeleteDepot({
                depot_id: id,
                changedUpdatedValue: "delete"
            });
            setIsDelete(false);
            fetchData();
            setSuccessMessage("Record deleted successfully");
        } catch (error) {
            setSuccessMessage("Error deleting record");
        }
    };


    const handleDelete = (functions) => {
        setIsDelete(true);
        setDeleteInfo(functions);
    }

    const handleClose = (event, reason) => {
        setIsDelete(false)
        setDeleteInfo(null);
    };

    const [successMessage, setSuccessMessage] = useState(null);
  

    // Sort rows by entry_date descending
    const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
    // Calculate pagination info
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;

    console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });

    return (
        <Box className={`${styles.cts_page}`} sx={{ padding: "0px !important", margin: "0px !important" }}>
            <Box className={`${styles.body}`}>
                <Breadcrumb
                    routeSegments={[
                        // { name: 'Dashbord', path: '/dashboard' },
                        { name: 'Depot List' },
                    ]}
                />




                <HeaderSection
                    title="DEPOT MASTER LIST
"
                    addNewPath="/masters/add-depot"
                    searchKey={searchKey}
                    handleSearch={handleSearch}
                    sortedRows={sortedRows}
                    fields={fields}
                    labels={labels}
                    filename="Depot List"
                    paginationInfo={paginationInfo}
                    controller={controller}
                    handleChangePage={handleChangePage}
                />

                <Paper sx={{ width: '100%',  }}>
                    <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align="left"
                                        sx={{ width: '10%' }} className={`${styles.table_head}`} onClick={() => HandleSort('depot_name', sortBy, setSortBy, rows)}>Depot Name<span className={`${styles.sort_icon}`}> {sortBy === 'depot_name' ? '▲' : '▼'} </span></StyledTableCell>
                                    <StyledTableCell align="left"
                                        className={`${styles.table_head}`}
                                        sx={{ width: '20%' }}
                                        onClick={() => HandleSort('depot_address', sortBy, setSortBy, rows)}>
                                        Depot Address<span className={`${styles.sort_icon}`}> {sortBy === 'depot_address' ? '▲' : '▼'} </span></StyledTableCell>
                                    
                                    <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort('contact_person', sortBy, setSortBy, rows)}>Contact Person<span className={`${styles.sort_icon}`}> {sortBy === 'contact_person' ? '▲' : '▼'} </span></StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort('contact_no', sortBy, setSortBy, rows)}>Contact No<span className={`${styles.sort_icon}`}> {sortBy === 'contact_no' ? '▲' : '▼'} </span></StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell>

                                </StyledTableRow>
                            </TableHead>
                            <TableBody sx={{ backgroundColor: '#fff' }}>
                                {Array.isArray(rows) && rows.map((row, index) => (
                                    <StyledTableRow
                                        key={row.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >

                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.depot_name}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.depot_address}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.contact_person}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.contact_no}</StyledTableCell>
                                        <StyledTableCell align="center" >
                                            <CustomePopover row={row} handleDelete={false}    handleCancel={false}  linkTo="/masters/add-depot"   handlePrint ={false}/>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                               <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>
                </Paper>

                <DeleteDialog
                    open={isDelete}
                    handleClose={handleClose}
                    deleteInfo={deleteInfo}
                    deleteRecord={deleteRecord}
                    deleteID={deleteInfo?.depot_id || null}
                    displayName={deleteInfo?.depot_id || ''}
                />
                <ReusableSnackbar
                    open={!!successMessage}
                    onClose={(event, reason) => {
                        if (reason !== 'clickaway') {
                            setSuccessMessage("");
                        }
                    }}
                    message={successMessage}
                    autoHideDuration={2000}
                    vertical="top"
                    horizontal="right"
                />
            </Box>
        </Box>
    )
}
export default DepotList;